import { ProductData } from "../types/explore-top-products.types";

export const extractEmiPrice = (productName: string): number | null => {
  const emiMatch = /EMI\s*@\s*₹\s*(\d+)/i.exec(productName);
  if (emiMatch?.[1]) {
    return parseInt(emiMatch[1], 10);
  }
  return null;
};

export const cleanProductTitle = (productName: string): string => {
  return productName?.trim();
};

export const calculateEmiPrice = (product: ProductData): number => {
  const extractedPrice = extractEmiPrice(product.product_name || "");
  if (extractedPrice) {
    return extractedPrice;
  }

  const unitPriceString = product.product_units?.[0]?.unit_price_string;
  if (unitPriceString) {
    const priceMatch = /₹\s*(\d+)/.exec(unitPriceString);
    if (priceMatch?.[1]) {
      const price = parseInt(priceMatch[1], 10);
      if (price > 0) {
        return price;
      }
    }
  }

  const unitPrice = product.product_units?.[0]?.unit_price;
  if (unitPrice && unitPrice > 0) {
    return unitPrice;
  }

  return 0;
};
